const modalNav = document.getElementById('js-modal-nav')
const dialogNav = new A11yDialog(modalNav)

const modalSearch = document.getElementById('js-modal-search')
const dialogSearch = new A11yDialog(modalSearch)

let modalHiking = document.getElementById('js-modal-hiking')
if(modalHiking) {
    let dialogHiking = new A11yDialog(modalHiking)
}

const modalShop = document.getElementById('js-modal-shop')
if(modalShop) {
    const dialogShop = new A11yDialog(modalShop)
}

// if (modalNav.hasAttribute('aria-modal="true"')) {
//   page.classList.add('is-overflow--hidden');
// }